<template>
    <div class="p-grid p-fluid">
        <card-seplag :titulo="`${this.dadosServidor.pessoa.nome}`">
            <div class="p-col-12">
            <Fieldset legend="Dados Pessoais" class="">
                <div class="p-grid">
                    <Rotulo nome="Matrícula:"  cols="6 3">
                        {{this.dadosServidor.matricula}}
                    </Rotulo>
                    <Rotulo nome="CPF:"  cols="6 3">
                        {{this.dadosServidor.pessoa.documentosPessoais.cpfFormatado}}
                    </Rotulo>
                    <Rotulo nome="Ramal:"  cols="6 3">
                        {{this.dadosServidor.pessoa.contato.telefone}}
                    </Rotulo>
                    <Rotulo nome="Sexo:"  cols="6 3">
                        {{this.dadosServidor.pessoa.sexo}} 
                    </Rotulo>
                    <br><br><br><br>
                    <Rotulo nome="Tratamento:"  cols="6 3">
                        {{this.dadosServidor.pessoa.tratamento}}
                    </Rotulo>
                    <Rotulo nome="Nascimento:"  cols="6 3">
                        {{this.dadosServidor.pessoa.dataNascimento}}
                    </Rotulo>
                    <Rotulo nome="Estado Civil:"  cols="6 3">
                        **
                    </Rotulo>
                    <Rotulo nome="Escolaridade:"  cols="6 3">
                        {{this.dadosServidor.pessoa.grauEscolaridade}}
                    </Rotulo>

                    <br><br><br><br>
                    <Rotulo nome="Nome do Pai:"  cols="12 6">
                        {{this.dadosServidor.pessoa.nomePai}}
                    </Rotulo>
                    <Rotulo nome="Nome da Mãe:"  cols="12 6">
                        {{this.dadosServidor.pessoa.nomeMae}}
                    </Rotulo>
                    
                </div>
            </Fieldset>
            </div>
            <div class="p-col-12">
            <Fieldset legend="Documentos">
                <div class="p-grid">
                    <Rotulo nome="Registro Geral:" cols="12 6">
                        {{this.dadosServidor.pessoa.documentosPessoais.rg}} - {{this.dadosServidor.pessoa.documentosPessoais.orgaoEmissor}}/{{this.dadosServidor.pessoa.documentosPessoais.ufEmissor}}
                    </Rotulo>
                    
                    <Rotulo nome="Título Eleitoral:" cols="12 6">
                        {{this.dadosServidor.pessoa.documentosPessoais.tituloEleitor}} - Zona {{this.dadosServidor.pessoa.documentosPessoais.zonaEleitor}} - Seção {{this.dadosServidor.pessoa.documentosPessoais.secaoEleitor}}  {{this.dadosServidor.pessoa.documentosPessoais.ufEleitor}}
                    </Rotulo>
                    <br><br><br>
                    <Rotulo nome="Carteira de Habilitação:" cols="12 6">
                         {{this.dadosServidor.pessoa.documentosPessoais.numeroCNH}} - Categoria {{this.dadosServidor.pessoa.documentosPessoais.categoriaCNH}} - Validade {{this.dadosServidor.pessoa.documentosPessoais.validadeCNH}} {{this.dadosServidor.pessoa.documentosPessoais.ufCNH}}
                    </Rotulo>
                    
                    <Rotulo nome="Carteira Profissional:" cols="12 6">
                        {{this.dadosServidor.pessoa.documentosPessoais.identidadeProfissional}}** - Seção**: - UF**:
                    </Rotulo>
                    <br><br><br>
                    <Rotulo nome="Documento Militar:" cols="12 6">
                        {{this.dadosServidor.pessoa.documentosPessoais.documentoMilitar}} - Série: {{this.dadosServidor.pessoa.documentosPessoais.serieMilitar}} - Categoria: {{this.dadosServidor.pessoa.documentosPessoais.categoriaMilitar}}
                    </Rotulo>
                    
                    <Rotulo nome="Identidade Profissional:" cols="12 6">
                        {{this.dadosServidor.pessoa.documentosPessoais.identidadeProfissional}} - {{this.dadosServidor.pessoa.documentosPessoais.tipoProfissional}}
                    </Rotulo>
                    <br><br><br>
                    <Rotulo nome="Certidão de Nascimento/Casamento:" cols="12 6">
                        {{this.dadosServidor.pessoa.documentosPessoais.certidaoNascimento}} - Livro: {{this.dadosServidor.pessoa.documentosPessoais.livroCertidao}} - Fls: {{this.dadosServidor.pessoa.documentosPessoais.folhaCertidao}} - Cartório: {{this.dadosServidor.pessoa.documentosPessoais.cartorioCertidao}}
                    </Rotulo>
                </div>
            </Fieldset>
            </div>
            <div class="p-col-12 p-md-6">
            <Fieldset legend="Endereço" class="p-col-12">
                <Rotulo nome="Logradouro:" cols="12">
                    {{this.dadosServidor.pessoa.endereco.tipoLogradouro}} {{this.dadosServidor.pessoa.endereco.logradouro}}, {{this.dadosServidor.pessoa.endereco.numero}}<br>
                    Bairro {{this.dadosServidor.pessoa.endereco.bairro}} - {{this.dadosServidor.pessoa.endereco.cidade}}/{{this.dadosServidor.pessoa.endereco.estado}}<br>
                    CEP: {{this.dadosServidor.pessoa.endereco.cep}}   
                </Rotulo>
            </Fieldset>
            </div>
            <div class="p-col-12 p-md-6">
                <Fieldset legend="Dados Sociais" class="p-col-12">
                    <Rotulo nome="PIS/PASEP:" cols="12">
                        {{this.dadosServidor.pessoa.documentosPessoais.numeroPISPASEP}}<br>Data: {{this.dadosServidor.pessoa.documentosPessoais.dataPIS}}<br>Banco: {{this.dadosServidor.pessoa.documentosPessoais.bancoPIS}}
                    </Rotulo>
                </Fieldset>                    
            </div>
            <div class="p-col-12 p-md-6  p-md-offset-5">
                <div class="p-col-12 p-md-5 p-md-offset-9">
                    <Button label="Gerar PDF" icon="pi pi-file-pdf" @click="gerarPDF" class="p-button-primary" />
                </div>
            </div>
            <CardExibirPDF v-if="pdfElement" v-model="exibirPDF" :nomeDocumento='nomeDocumentoPDF' :tituloTela="'PDF dos Dados Pessoais'" :position="'top'" :tamanhoTela="'55.em'"  :alturaTela="'55.em'" :pdfElement="pdfElement" />
        </card-seplag>
    </div>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
// import FormSeplag from '@/template/FormSeplag.vue'
import { baseApiUrl } from '@/config/global'
import CardExibirPDF from '@/template/CardExibirPDF.vue'



export default {
    name: 'dadosPessoais',
    components: { CardSeplag, Rotulo, CardExibirPDF},    
    data(){
        return{
            apiUrlRecurso: 'dadospessoais',
            matricula: null,
            pdfElement: null,
            exibirPDF: false,
            nomeDocumentoPDF: 'Dados do Servidor',
            dadosServidor: {matricula:null,
                                pessoa:{
                                    nome:null,
                                    sexo:null,
                                    tratamento:null,
                                    dataNascimento:null,
                                    grauEscolaridade: null,
                                    nomePai:null,
                                    nomeMae:null,
                                    documentosPessoais: {
                                        cpf:null,
                                        rg:null,
                                        orgaoEmissor:null,
                                        ufEmissor:null,
                                        tituloEleitor:null,
                                        zonaEleitor:null,
                                        secaoEleitor:null,
                                        ufEleitor:null,
                                        numeroCNH:null,
                                        categoriaCNH:null,
                                        validadeCNH:null,
                                        ufCNH:null,
                                        identidadeProfissional:null,
                                        tipoProfissional:null,
                                        documentoMilitar:null,
                                        serieMilitar:null,
                                        categoriaMilitar:null,
                                        certidaoNascimento:null,
                                        livroCertidao:null,
                                        folhaCertidao:null,
                                        cartorioCertidao:null,
                                        numeroPISPASEP:null,
                                        dataPIS:null,
                                        bancoPIS:null
                                    },
                                    contato:{
                                        telefone:null
                                    },
                                    endereco:{
                                        tipoLogradouro:null,
                                        logradouro:null,
                                        numero:null,
                                        bairro:null,
                                        cidade:null,
                                        estado:null,
                                        cep:null
                                    }
                                } 
                            }
        }
    },
    methods:{
        carregarDados(){
          this.dadosServidor = this.$store.getters.getUser.dadosUsuariosCustomizados  
        },
        gerarPDF(){
            this.$http.post(`${baseApiUrl}/dadospessoais/pdf/${this.$store.getters.getMatricula}`).then(res => {
                this.pdfElement = res.data.dadosRelatorioBase64
                this.nomeDocumentoPDF = res.data.nomeArquivo
                this.exibirPDF = true
            })

        }
    },
    mounted(){
        
        this.carregarDados()

    },
    created(){
        
    }
}
</script>
<style scoped>

</style>